<template>
    <v-card-text v-for="type in relationshipTypes">
        <experiment-relationship-list
            :type="type"
            :relationships="getExperimentRelationshipsForType(type)"
        />
    </v-card-text>
</template>
<script setup lang="ts">
import ExperimentRelationshipList from "@/components/Experiments/ExperimentRelationshipList.vue";
import {
    DEFAULT_EXPERIMENT_SETUP_CONFIG_TYPES,
    ExperimentRelationshipDTO,
    ExperimentRelationshipsForType,
} from "@/services/experimentRelationships/models";
import { computed } from "vue";
import _ from "lodash";

const { experimentRelationships } = defineProps<{
    experimentRelationships: ExperimentRelationshipsForType<ExperimentRelationshipDTO>[];
}>();

const relationshipTypes = computed(() => {
    const types: string[]  = [];

    if (experimentRelationships.length > 0) {
        for (const relationshipsForType of experimentRelationships) {
            types.push(relationshipsForType.type);
        }
    }

    return _.union(DEFAULT_EXPERIMENT_SETUP_CONFIG_TYPES, types);
});

function getExperimentRelationshipsForType(type: string): ExperimentRelationshipDTO[] {
    if (experimentRelationships.length > 0) {
        const forType = experimentRelationships.find((relationshipsForType) => relationshipsForType.type === type);
        if (forType) {
            return forType.relationships;
        }
    }
    return [];
}

</script>
